<!--suppress CssUnusedSymbol -->
<template>
  <div class="bg-white shadow-2xl rounded-xl sm:rounded-full">
    <div class="flex flex-wrap items-center sm:flex-no-wrap md:items-stretch">
      <div
        class="w-full py-1 pl-4 pr-4 border-b-2 sm:w-1/2 sm:flex-1 lg:flex-auto lg:w-2/6 sm:border-b-0 sm:border-r-2 md:py-2 md:pl-8"
      >
        <div class="h-full p-float-label p-input-filled">
          <dropdown
            id="country"
            v-model="type"
            :options="buildingTypes"
            optionLabel="name"
            class="flex items-center w-full h-full"
            @input="typeValid = true"
          />
          <label
            for="country" :class="!typeValid ? 'text-red-400' : 'text-blue-500'" class="uppercase"
          >Hoone liik
          </label>
        </div>
      </div>

      <div class="w-full px-4 py-1 border-b-2 sm:w-1/2 sm:flex-1 lg:flex-auto lg:w-4/6 md:py-2 sm:border-b-0">
        <div class="h-full p-float-label p-input-filled">
          <input-number
            id="size"
            placeholder=" "
            v-model="size"
            :use-grouping="false"
            class="w-full h-full"
            @input="sizeValid = true"
            @keyup.enter="search"
          />
          <label
            for="size" :class="!sizeValid ? 'text-red-400' : 'text-blue-500'" class="uppercase"
          >Hoone pindala (m<sup>2</sup>)
          </label>
        </div>
      </div>

      <div class="flex justify-center w-full p-4 sm:flex-1 sm:p-1 md:p-2">
        <button class="w-full text-white bg-orange-400 btn lg:w-48" @click="search">Jätka</button>
      </div>
    </div>
  </div>
</template>

<script>
import {postSearch} from "@/store/public.api";

export default {
  props: {
    buildingTypes: Array
  },
  data() {
    return {
      size: null,
      sizeValid: true,
      type: null,
      typeValid: true
    }
  },
  methods: {
    search() {
      this.sizeValid = this.size
      this.typeValid = this.type

      if (this.sizeValid && this.typeValid) {
        this.$gtm.trackEvent({
          event: null, // Event type [default = 'interaction'] (Optional)
          category: 'Home',
          action: 'click',
          label: 'Home page continue project creation',
          value: 5000,
          noninteraction: false, // Optional
        });
        postSearch(this.type.id, this.size);
        this.$router.push({
          path: '/project/new',
          query: {
            size: this.size,
            type: this.type.id,
          },
        });
      }
    }
  }
}
</script>

<style scoped>
.p-float-label input:focus ~ label,
.p-float-label input.p-filled ~ label,
.p-float-label textarea:focus ~ label,
.p-float-label textarea.p-filled ~ label,
.p-float-label .p-inputwrapper-focus ~ label,
.p-float-label .p-inputwrapper-filled ~ label {
  top: theme('spacing.3');
  font-size: 11px;
}

@screen sm {
  .p-float-label input:focus ~ label,
  .p-float-label input.p-filled ~ label,
  .p-float-label textarea:focus ~ label,
  .p-float-label textarea.p-filled ~ label,
  .p-float-label .p-inputwrapper-focus ~ label,
  .p-float-label .p-inputwrapper-filled ~ label {
    top: theme('spacing.4');
    font-size: 12px;
  }
}

::v-deep .p-dropdown .p-dropdown-trigger {
  background-size: 26px;
  height: 2.357rem;
}

@screen sm {
  ::v-deep .p-dropdown .p-dropdown-trigger {
    height: 100%;
  }
}

::v-deep .p-inputtext {
  @apply pb-0 pt-4 px-4;
}

@screen sm {
  ::v-deep .p-inputtext {
    @apply text-lg;
  }
}

::v-deep .p-float-label > label {
  left: 1rem;
  font-size: 14px;
}

@screen sm {
  ::v-deep .p-float-label > label {
    font-size: 1rem;
  }
}

::v-deep .p-dropdown-trigger-icon {
  color: theme('colors.gray.900');
}
</style>
